// Pasos de la página de documentos y "primer grupo que falta". Puro, sin React.
export const PASOS_PF = ["edosCta", "address", "references", "identifications"];
export const PASOS_PM = ["edosCta", "address", "actaRppPoderes", "edosFinancieros", "edosCtaAval", "addressAval", "identifications"];
export const pasosDe = (tipo) => (tipo === 2 ? PASOS_PM : PASOS_PF);          // misma regla que submit()
const BANDERA = { references: "reference" };                                   // así se guarda en uploadDocuments
export const banderaDe = (paso) => BANDERA[paso] || paso;
export const primerGrupoQueFalta = (pasos, docs = {}) => pasos.find((p) => !docs[banderaDe(p)]) || "ok";
